import {
  SalesItemResetCategoryModel,
  ISalesItemResetCategoryModel,
} from '@common/models/SalesItemResetCategoryModel';
import { http } from '@common/utils';
import { trackPromise } from 'react-promise-tracker';
import { ServiceHelper } from '../serviceHelper';
import { ServiceMethodOptions } from '../types';

export class SalesItemResetCategoryService {
  private static baseUrl: string = '/api/salesitemresetcategory';
  static tags = {
    upsertSalesItemResetCategory: 'upsertSalesItemResetCategory',
    getSalesItemResetCategories: 'getSalesItemResetCategories',
    deleteSalesItemResetCategory: 'deleteSalesItemResetCategory',
  };

  static getSalesItemResetCategories = (
    options?: ServiceMethodOptions,
  ): Promise<SalesItemResetCategoryModel[]> => {
    return trackPromise(
      new Promise<SalesItemResetCategoryModel[]>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .get<ISalesItemResetCategoryModel[]>()
          .then((response) => {
            ServiceHelper.showSuccess(
              'Sales Item Reset Category fetched.',
              options,
            );
            resolve(response);
          })
          .catch((err) => {
            ServiceHelper.showError(
              'Failed to get Sales Item Reset Category.',
              options,
            );
            reject(err);
          });
      }),
      this.tags.getSalesItemResetCategories,
    );
  };

  static upsertSalesItemResetCategory = (
    data: ISalesItemResetCategoryModel,
    options?: ServiceMethodOptions,
  ): Promise<SalesItemResetCategoryModel> => {
    return trackPromise(
      new Promise<ISalesItemResetCategoryModel>((resolve, reject) => {
        http(`${this.baseUrl}`)
          .post<ISalesItemResetCategoryModel>(data)
          .then((response) => {
            ServiceHelper.showSuccess(
              'Sales Item Reset Category updated.',
              options,
            );
            resolve(new SalesItemResetCategoryModel(response));
          })
          .catch((err) => {
            ServiceHelper.showError(
              'Failed to update Sales Item Reset Category.',
              options,
            );
            reject(err);
          });
      }),
      this.tags.upsertSalesItemResetCategory,
    );
  };
  static deleteSalesItemResetCategory = (
    salesItemResetCategoryId: number,
    options?: ServiceMethodOptions,
  ): Promise<boolean> => {
    return trackPromise(
      new Promise<boolean>((resolve, reject) => {
        http(`${this.baseUrl}/${salesItemResetCategoryId}`)
          .delete()
          .then(() => {
            ServiceHelper.showSuccess(
              'Sales Item Reset Category has been deleted.',
              options,
            );
            resolve(true);
          })
          .catch((err) => {
            ServiceHelper.showError(
              'Failed to delete Sales Item Reset Category.',
              options,
            );
            reject(err);
          });
      }),
      this.tags.deleteSalesItemResetCategory,
    );
  };
}
